import styled from "styled-components";
import { Heading1, SubHeading } from "../../../../common/styled-components/styled-components";
import { breakpoints } from '../../../../../../app/js/utils/responsive_utilities';
import { white } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';
import { assetPath } from 'web-helper';
import BlueWaveMob from "~images/sem/blue-wave-mob.svg";
import BlueWaveWeb from "~images/sem/blue-wave-web.svg";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: url(${assetPath(BlueWaveMob)}) center center/cover no-repeat;
  ${styledFont("Graphie")}
  padding: 4rem 1.6rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${breakpoints.lg}px) {
    padding: 9rem 2rem 10rem;
    background: url(${assetPath(BlueWaveWeb)}) center center/cover no-repeat;

  }
`;
export const HeadingText = styled(Heading1)`
  color: ${white};
  margin: auto;
  padding-bottom: 1.5rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.6, 7)};
  }
`;
export const SubHeadingText = styled(SubHeading)`
  width: auto;
  color: ${white};
  ${styledFont("Graphie", 2, 2.4, 7)};
  margin: 14rem 0 0 0;
  text-align: left;
  padding-top: 1rem;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 3.6, 4, 7)};
    padding-top: 4rem;
    margin-top: 4rem;
  }
`;
export const ListWrapper = styled.ul`
  padding: 2rem 0 2.8rem;
  list-style: none;
`;

export const RatingImageWrapper = styled.div`
  padding: 2rem 0;
`;

export const Rating = styled.p`
  margin: 0;
  ${styledFont("Graphie", 1.6, 2.4, 7)}
  color: ${white};
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 2, 2.4, 7)};
  }
`;